var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row boxHead"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('h2',[_vm._v(_vm._s(_vm.labels[_vm.labelOptions[_vm.type]]))]),_c('br',{staticClass:"hidden-xs"})])]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }